<template>
    <div class="pagination-table">
        <ve-table
            :table-data="data"
            :cell-style-option="cellStyleOption"
            :cellSelectionOption="cellSelectionOption"
            :row-style-option="rowStyleOption"
            :border-around="false"
            :border-x="true"
            :border-y="false"
            :sort-option="sortOption"
            class="pagination-table"
            v-bind="$attrs"
            :fixed-header="false"

        />
        <div class="pagination-table__pagination" v-if="data.length > 0">
            {{ itemsAmount }}
            <ve-pagination
                :total="totalCount"
                :page-index="page"
                :page-size="pageSize"
                @on-page-number-change="pageNumberChange"
                :layout="['prev', 'pager', 'next']"
            />
            <div class="pagination-table__page-size">
                {{ $t('OrganizationReport.show' )}}
                <TotemSelect
                    :options="options"
                    @input="pageSizeChange"
                    :value="pageSize"
                    :clearable="false"
                    class="pagination-table__page-size-select"
                    :width="70"
                />
                {{ itemsPerPage }}
            </div>
        </div>
        <div class="pagination-table__empty" v-if="data.length === 0">
            <span class="pagination-table__empty-icon icon-warning"></span>
            <span v-html="$t('OrganizationReport.empty_table')"></span>
        </div>
    </div>
</template>
<script>
    import tableHelper from 'components/user/organizationreport/tables/helpers/table-helper'

    export default {
        name: 'pagination-table',
        mixins: [ tableHelper ],
        props: {
            data: {
                type: Array
            },
            totalCount: {
                type: Number
            },
            dataType: {
                type: String
            },
            page: {
                type: Number
            }
        },
        data () {
            return {
                rowStyleOption: {
                    stripe: true
                },
                options: [10, 20, 25, 50, 100],
                pageSize: 20,
                sortOption: {
                    sortChange: (sortParams) => {
                        this.$emit('pageNumberChange', 1)
                        this.$emit('sortChange', sortParams)
                    }
                }
            }
        },
        computed: {
            usersFrom () {
                if (this.page === 1) {
                    return this.page
                }
                return this.page * this.pageSize - this.pageSize + 1
            },
            usersTo () {
                let usersTo = this.usersFrom + this.pageSize - 1
                if (this.totalCount < usersTo ) {
                    let diff = usersTo - this.totalCount
                    return usersTo - diff
                }
                return usersTo
            },
            itemsAmount () {
                return this.$t('OrganizationReport.show_items_amount', {
                    itemsFrom: this.usersFrom,
                    itemsTo: this.usersTo,
                    itemsTotal: this.totalCount,
                    itemsType: this.dataType
                })
            },
            itemsPerPage () {
                return this.$t('OrganizationReport.items_per_page', { itemsType: this.dataType })
            }
        },
        methods: {
            pageNumberChange (pageIndex) {
                this.$emit('pageNumberChange', pageIndex)
            },
            pageSizeChange (pageSize) {
                this.pageSize = pageSize
                this.$emit('pageNumberChange', 1)
                this.$emit('pageSizeChange', pageSize)
            }
        }
    }
</script>

<style lang="scss">
    .pagination-table {
        .table-header-cell {
            background: $gallery !important;
            font-family: Nunito-ExtraBold, sans-serif;
            text-transform: uppercase;
            font-size: 1.4rem;
            height: 47px;
            white-space: nowrap;
        }

        .ve-table {
            .ve-table-header-th {
                vertical-align: baseline;
            }

            .ve-table-sort-icon.active {
                color: $mine_shaft !important;
            }

            .ve-table-content {
                border-top: 1px solid $dark_gray;
            }

            tr.ve-table-body-tr {
                height: 48px !important;
                &:hover {
                    cursor: pointer;
                    td {
                        background: $champagne !important;
                    }
                }
            }

            td.ve-table-body-td {
                padding: 6px 10px !important;
            }
        }

        &__pagination {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 20px 0 0;
        }

        &__page-size {
            display: flex;
            align-items: center;
            gap: 5px;
        }

        &__page-size-select.totem-select {
            .vs__dropdown-toggle {
                border-radius: 4px;
                border: 1px solid $mine_shaft;
                min-width: 70px;
                height: 26px;
            }

            .vs__dropdown-menu {
                border-radius: 0 0 4px 4px;
                min-width: 70px;
            }

            .vs--open {
                .vs__dropdown-toggle {
                    border-radius: 4px 4px 0 0;
                }
            }

            .vs__selected-options {
                padding-left: 0;
            }

            &.small {
                .vs__selected {
                    margin: 0;
                }
                .vs__dropdown-toggle {
                    padding: 0 0 4px 0;
                }
            }
        }

        &__empty {
            padding: 30px;
            display: flex;
            justify-content: center;
            border: 1px solid $gallery;
            line-height: 2rem;
        }

        &__empty-icon {
            margin-right: 10px;
            color: $thunderbird;
            font-size: 2rem;
        }

        .ve-pagination {
            display: flex;
            justify-content: center;
            justify-items: center;

            .ve-pagination-li {
                border-radius: 100%;
                background: transparent;
                border: none;

                &:hover {
                    border-color: $orange;

                    & > a {
                        color: $orange;
                    }
                }

                & > a {
                    &:hover {
                        color: $orange;
                    }
                }

                &:last-of-type {
                    margin-right: 0;
                }

                &.ve-pagination-li-active {
                    color: $white;
                    background: $orange;
                    border-color: $orange;

                    &:hover a,
                    & > a {
                        color: $white;
                    }
                }

                &.ve-pagination-prev,
                &.ve-pagination-next {
                    background: $gallery;

                    & a > i {
                        color: $black;
                        font-size: 2.4rem;
                        font-weight: 600;
                        margin: 4px 0 0;
                    }

                    &:hover i {
                        color: $orange;
                    }
                }
            }

            .ve-pagination-disabled {
                &.ve-pagination-prev,
                &.ve-pagination-next {
                    & a > i {
                        color: $silver_chalice;
                    }

                    &:hover i {
                        color: $silver_chalice;
                        &:before {
                            cursor: not-allowed;
                        }
                    }
                }
            }

            .ve-pagination-pager {
                background: $gallery;
                border-radius: 50px;
                margin: 0 10px;
            }

            .ve-pagination-jump-prev,
            .ve-pagination-jump-next {

                &:after {
                    font-size: 6px;
                }

                &:hover i {
                    color: $orange;
                    font-size: 1.5rem;
                }
            }

            .ve-pagination-select {
                position: absolute;
                right: 20px;

                &:before {
                    content: 'Show';
                    display: inline-block;
                    position: absolute;
                    right: 110%;

                }
            }
        }

        .iconfont-vet {
            font-family: 'iconfont-vet' !important;
        }
    }
    .ve-dropdown-popper {
        font-family: Nunito-Regular;
        right: 24px;
        left: auto !important;
    }
</style>
